// Homepage sections — statement, curved marquee, why, sticky story, reviews, socials, inquiry.
// Config-driven (reads `cfg`, falls back to the original design content).
// (useIsMobile, H, P come from cravy-sections1.js; Reveal/Marquee/useScrollProgress from cravy-anims.js)

// ---- WHY PEOPLE LOVE IT ----
function WhyPeople({
  cfg
}) {
  const c = cfg || {};
  const m = useIsMobile();
  const bg = P(c.bg, 'var(--cravy-white)'),
    accent = P(c.accent, 'var(--cravy-red)');
  const cards = [{
    id: 'why-1',
    top: '2%',
    left: '-16%',
    w: '46%',
    rot: -8,
    z: 1,
    ar: '3/4',
    img: P(c.img1, '')
  }, {
    id: 'why-2',
    top: '0%',
    left: '30%',
    w: '54%',
    rot: 7,
    z: 3,
    ar: '3/4.4',
    img: P(c.img2, '')
  }, {
    id: 'why-3',
    top: '38%',
    left: '8%',
    w: '48%',
    rot: -3,
    z: 2,
    ar: '3/4.2',
    img: P(c.img3, '')
  }];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Why people love it",
    style: {
      background: bg,
      position: 'relative',
      zIndex: 0,
      overflow: 'hidden',
      minHeight: m ? 'auto' : '100vh',
      display: 'grid',
      gridTemplateColumns: m ? '1fr' : '1.15fr 1fr',
      gap: 'clamp(24px,3vw,60px)',
      padding: 'clamp(50px,7vh,90px) clamp(20px,5vw,80px)',
      boxSizing: 'border-box',
      alignItems: 'stretch'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: m ? {
      display: 'flex',
      flexDirection: 'column',
      gap: 14,
      padding: '4px 0'
    } : {
      position: 'relative',
      minHeight: 'clamp(520px,88vh,900px)'
    }
  }, cards.map((cd, i) => /*#__PURE__*/React.createElement("div", {
    key: cd.id,
    style: m ? {
      width: '58%',
      alignSelf: i % 2 ? 'flex-end' : 'flex-start',
      transform: `rotate(${cd.rot * 0.6}deg)`,
      background: '#fff',
      borderRadius: 18,
      padding: 10,
      boxSizing: 'border-box',
      boxShadow: '0 24px 50px rgba(0,0,0,0.14)'
    } : {
      position: 'absolute',
      top: cd.top,
      left: cd.left,
      width: cd.w,
      zIndex: cd.z,
      transform: `rotate(${cd.rot}deg)`,
      background: '#fff',
      borderRadius: 22,
      padding: 14,
      boxSizing: 'border-box',
      boxShadow: '0 24px 50px rgba(0,0,0,0.14)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      borderRadius: 14,
      overflow: 'hidden',
      aspectRatio: cd.ar,
      background: 'var(--cravy-yellow)'
    }
  }, /*#__PURE__*/React.createElement("image-slot", {
    id: cd.id,
    shape: "rounded",
    radius: "14",
    fit: "cover",
    src: cd.img,
    placeholder: "Drop a photo or video still",
    style: {
      width: '100%',
      height: '100%'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      right: 12,
      bottom: 12,
      width: 38,
      height: 38,
      borderRadius: '50%',
      background: 'rgba(0,0,0,0.45)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 9v6h4l5 4V5L7 9H3zm13.5 3a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4z"
  }))))))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: m ? 'auto' : 'clamp(520px,80vh,900px)'
    }
  }, /*#__PURE__*/React.createElement(Reveal, {
    kind: "up"
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: '0 0 22px',
      color: accent,
      fontSize: 'clamp(34px,4.4vw,68px)',
      lineHeight: 0.92,
      letterSpacing: 'var(--cravyy-tracking)'
    },
    dangerouslySetInnerHTML: H(P(c.heading, 'Less time cooking\nMore time together'))
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      maxWidth: 520,
      fontFamily: 'var(--font-body)',
      fontWeight: 500,
      fontSize: 'clamp(15px,1.3vw,21px)',
      lineHeight: 1.35,
      color: 'var(--cravy-maroon)'
    },
    dangerouslySetInnerHTML: H(P(c.body, 'Great moments shouldn’t be spent standing over the stove. Cravy gets you back to the table faster with restaurant-quality fries ready in minutes.'))
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: m ? 'column' : 'row',
      alignItems: m ? 'flex-start' : 'center',
      gap: 18,
      marginTop: 34,
      fontFamily: 'var(--font-body)'
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: P(c.btn_link, '/collections/all'),
    className: "whybtn",
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      cursor: 'pointer',
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 46,
      height: 46,
      borderRadius: '50%',
      background: accent,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "2.5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 17L17 7M9 7h8v8"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      background: accent,
      color: '#fff',
      fontWeight: 700,
      fontSize: 'clamp(16px,1.3vw,21px)',
      padding: '12px 26px',
      borderRadius: 999
    }
  }, P(c.btn_text, 'Buy now'))), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: accent,
      fontSize: 19,
      letterSpacing: 2
    }
  }, "★★★★☆"), /*#__PURE__*/React.createElement("a", {
    href: "#reviews",
    style: {
      fontWeight: 600,
      fontSize: 14,
      color: 'var(--cravy-maroon)'
    }
  }, P(c.reviews_text, '3158 Reviews'))))), /*#__PURE__*/React.createElement("div", {
    style: m ? {
      textAlign: 'center',
      color: 'var(--cravy-maroon)',
      marginTop: 34
    } : {
      position: 'absolute',
      bottom: 'clamp(20px,5vh,50px)',
      right: 'clamp(20px,4vw,80px)',
      textAlign: 'center',
      color: 'var(--cravy-maroon)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-body)',
      fontStyle: 'italic',
      fontWeight: 600,
      fontSize: 20,
      transform: 'rotate(-6deg)'
    },
    dangerouslySetInnerHTML: H(P(c.note, 'why people\nlove it'))
  }), /*#__PURE__*/React.createElement("svg", {
    width: "52",
    height: "74",
    viewBox: "0 0 52 74",
    fill: "none",
    stroke: "var(--cravy-maroon)",
    strokeWidth: "2.5",
    strokeLinecap: "round",
    style: {
      marginTop: 6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 4 C 20 18, 8 36, 10 62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 52 L 10 63 L 20 57"
  })))));
}
window.CravyHome.why = WhyPeople;

// ---- CURVED MARQUEE (transition strip) ----
function CurvedMarquee({
  text,
  speed = 40,
  topBg,
  bottomBg,
  band = '#000',
  color = 'var(--cravy-yellow)'
}) {
  const tpRef = React.useRef(null);
  const rep = text + ' · ';
  React.useEffect(() => {
    const tp = tpRef.current;
    if (!tp) return;
    let raf,
      w = 0;
    try {
      const total = tp.getComputedTextLength();
      w = total / 14;
    } catch (e) {
      w = 900;
    }
    if (!w) w = 600;
    const t0 = performance.now();
    const pxPerSec = 2600 / speed;
    const tick = now => {
      const off = -((now - t0) / 1000 * pxPerSec % w);
      tp.setAttribute('startOffset', off);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [text, speed]);
  return /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    style: {
      overflow: 'hidden',
      lineHeight: 0,
      marginTop: '-1px'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 1440 560",
    style: {
      width: '100%',
      height: 'auto',
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: "-10",
    y: "-10",
    width: "1460",
    height: "580",
    fill: topBg
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -160 460 Q 720 60 1600 460 L 1600 570 L -160 570 Z",
    fill: bottomBg
  }), /*#__PURE__*/React.createElement("path", {
    id: "cm-path",
    d: "M -160 460 Q 720 60 1600 460",
    fill: "none",
    stroke: band,
    strokeWidth: "250"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fontFamily: 'var(--font-statement)',
      fontSize: 190,
      fontWeight: 400,
      textTransform: 'uppercase',
      letterSpacing: '-8px'
    },
    fill: color,
    dy: "66"
  }, /*#__PURE__*/React.createElement("textPath", {
    ref: tpRef,
    href: "#cm-path",
    startOffset: "0"
  }, Array(14).fill(rep).join('')))));
}
function HomeCurve({
  cfg
}) {
  const c = cfg || {};
  return /*#__PURE__*/React.createElement(CurvedMarquee, {
    text: P(c.text, 'Cravetastic fries'),
    speed: Number(P(c.speed, 48)),
    topBg: P(c.topBg, 'var(--cravy-white)'),
    bottomBg: P(c.bottomBg, 'var(--cravy-orange)'),
    band: P(c.band, '#000'),
    color: P(c.color, 'var(--cravy-yellow)')
  });
}
window.CravyHome.curve = HomeCurve;

// ---- STATEMENT (scattered hover words) ----
function scallopPath(n, R, r) {
  const cx = 50,
    cy = 50;
  let d = '';
  for (let i = 0; i <= n; i++) {
    const a = i / n * Math.PI * 2 - Math.PI / 2;
    const x = cx + R * Math.cos(a),
      y = cy + R * Math.sin(a);
    d += i === 0 ? `M ${x.toFixed(2)} ${y.toFixed(2)}` : ` A ${r} ${r} 0 0 1 ${x.toFixed(2)} ${y.toFixed(2)}`;
  }
  return d + ' Z';
}
const STMT_SHAPES = [{
  k: scallopPath(12, 44, 13),
  c: 'var(--cravy-green)'
}, {
  k: 'M50 4 C72 2 94 16 95 40 C96 62 84 88 60 94 C38 99 12 88 7 64 C2 42 10 20 28 10 C36 6 42 5 50 4 Z',
  c: '#1a1a1a'
}, {
  k: scallopPath(9, 43, 18),
  c: 'var(--cravy-maroon)'
}, {
  k: 'M46 6 C68 -2 92 12 94 34 C96 54 90 78 70 90 C52 100 24 96 12 78 C0 60 4 34 18 20 C26 12 36 10 46 6 Z',
  c: 'var(--cravy-green)'
}, {
  k: scallopPath(14, 45, 11),
  c: '#1a1a1a'
}];
const STMT_POS = [{
  L: {
    top: '6%',
    left: '-4%',
    rot: -12
  },
  R: {
    top: '52%',
    right: '-5%',
    rot: 10
  }
}, {
  L: {
    top: '40%',
    left: '-6%',
    rot: 8
  },
  R: {
    top: '4%',
    right: '-3%',
    rot: -9
  }
}, {
  L: {
    top: '18%',
    left: '-3%',
    rot: -7
  },
  R: {
    top: '34%',
    right: '-6%',
    rot: 12
  }
}, {
  L: {
    top: '55%',
    left: '-5%',
    rot: 11
  },
  R: {
    top: '14%',
    right: '-4%',
    rot: -11
  }
}, {
  L: {
    top: '30%',
    left: '-4%',
    rot: -10
  },
  R: {
    top: '48%',
    right: '-3%',
    rot: 7
  }
}];
function StmtBlob({
  i,
  spin
}) {
  const s = STMT_SHAPES[i % STMT_SHAPES.length];
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 100 100",
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '150%',
      height: '150%',
      transform: `translate(-50%,-50%) rotate(${spin}deg)`,
      zIndex: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: s.k,
    fill: s.c
  }));
}
function Statement({
  cfg
}) {
  const c = cfg || {};
  const [hov, setHov] = React.useState(2);
  const m = useIsMobile();
  const words = [{
    w: P(c.word1, 'CATEGORY LEADING'),
    imgL: P(c.img1L, ''),
    imgR: P(c.img1R, '')
  }, {
    w: P(c.word2, 'FROZEN FRIES'),
    imgL: P(c.img2L, ''),
    imgR: P(c.img2R, '')
  }, {
    w: P(c.word3, 'THAT EVERYONE LOVES!'),
    imgL: P(c.img3L, ''),
    imgR: P(c.img3R, '')
  }, {
    w: P(c.word4, 'FRESH , EXTRA CRISPY'),
    imgL: P(c.img4L, ''),
    imgR: P(c.img4R, '')
  }, {
    w: P(c.word5, '& PURE FUN !'),
    imgL: P(c.img5L, ''),
    imgR: P(c.img5R, '')
  }];
  const bg = P(c.bg, 'var(--cravy-white)'),
    accent = P(c.accent, 'var(--cravy-red)');
  const a = STMT_POS[hov];
  const packW = m ? 'min(42vw,180px)' : 'clamp(180px,20vw,340px)';
  const Ltop = m ? hov % 2 ? '74%' : '3%' : a.L.top,
    Lleft = m ? '-9%' : a.L.left;
  const Rtop = m ? hov % 2 ? '4%' : '70%' : a.R.top,
    Rright = m ? '-9%' : a.R.right;
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Statement",
    style: {
      background: bg,
      position: 'relative',
      overflow: 'hidden',
      minHeight: '100vh',
      padding: '90px clamp(20px,6vw,100px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box'
    }
  }, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      top: Ltop,
      left: Lleft,
      width: packW,
      transform: `rotate(${a.L.rot}deg)`,
      transition: 'top .7s cubic-bezier(.22,.9,.3,1), left .7s cubic-bezier(.22,.9,.3,1), transform .7s cubic-bezier(.22,.9,.3,1)',
      pointerEvents: 'none',
      zIndex: 1
    }
  }, /*#__PURE__*/React.createElement(StmtBlob, {
    i: hov,
    spin: -8
  }), words.map((s, i) => /*#__PURE__*/React.createElement("img", {
    key: i,
    src: s.imgL,
    alt: "",
    style: {
      position: 'relative',
      zIndex: 1,
      width: '100%',
      gridArea: '1/1',
      borderRadius: 'clamp(16px,1.6vw,26px)',
      display: i === hov ? 'block' : 'none',
      filter: 'drop-shadow(0 18px 30px rgba(0,0,0,0.18))',
      animation: i === hov ? 'fadein .5s ease both' : 'none'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      top: Rtop,
      right: Rright,
      width: packW,
      transform: `rotate(${a.R.rot}deg)`,
      transition: 'top .7s cubic-bezier(.22,.9,.3,1), right .7s cubic-bezier(.22,.9,.3,1), transform .7s cubic-bezier(.22,.9,.3,1)',
      pointerEvents: 'none',
      zIndex: 1
    }
  }, /*#__PURE__*/React.createElement(StmtBlob, {
    i: hov + 2,
    spin: 10
  }), words.map((s, i) => /*#__PURE__*/React.createElement("img", {
    key: i,
    src: s.imgR,
    alt: "",
    style: {
      position: 'relative',
      zIndex: 1,
      width: '100%',
      borderRadius: 'clamp(16px,1.6vw,26px)',
      display: i === hov ? 'block' : 'none',
      filter: 'drop-shadow(0 18px 30px rgba(0,0,0,0.18))',
      animation: i === hov ? 'fadein .5s ease .08s both' : 'none'
    }
  }))), /*#__PURE__*/React.createElement(Reveal, {
    kind: "up",
    style: {
      position: 'relative',
      textAlign: 'center',
      zIndex: 2
    }
  }, words.map((s, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    onMouseEnter: () => setHov(i),
    onClick: () => setHov(i),
    style: {
      fontFamily: 'var(--font-statement)',
      fontWeight: 400,
      fontSize: m ? 'clamp(38px,10.5vw,64px)' : 'clamp(64px,9.5vw,150px)',
      lineHeight: m ? 0.9 : 0.82,
      letterSpacing: '-0.09em',
      textTransform: 'uppercase',
      color: i === hov ? accent : '#000',
      transition: 'color .35s ease',
      cursor: 'default',
      whiteSpace: m ? 'normal' : 'nowrap'
    },
    dangerouslySetInnerHTML: H(s.w)
  }))));
}
window.CravyHome.statement = Statement;

// ---- STORY (sticky steps) ----
function Story({
  cfg
}) {
  const c = cfg || {};
  const [idx, setIdx] = React.useState(0);
  const m = useIsMobile();
  const steps = [{
    n: '01',
    label: P(c.step1_label, 'Field'),
    img: P(c.step1_img, ''),
    h: P(c.step1_h, 'Farm-picked potatoes'),
    b: P(c.step1_b, 'Carefully selected potatoes, cut thick and golden. Quality you can count on in every bite.'),
    c: P(c.step1_color, 'var(--cravy-red)')
  }, {
    n: '02',
    label: P(c.step2_label, 'Fryer'),
    img: P(c.step2_img, ''),
    h: P(c.step2_h, 'Golden crispy coating'),
    b: P(c.step2_b, 'Our signature crisp holds from the oven to the table. Crispy in every bite — first to last.'),
    c: P(c.step2_color, 'var(--cravy-green)')
  }, {
    n: '03',
    label: P(c.step3_label, 'Freezer'),
    img: P(c.step3_img, ''),
    h: P(c.step3_h, 'Frozen at peak fresh'),
    b: P(c.step3_b, 'Locked in at peak freshness so convenience never comes at the cost of taste.'),
    c: P(c.step3_color, 'var(--cravy-maroon)')
  }];
  React.useEffect(() => {
    if (m) return; // mobile: all steps stay open, no auto-cycling
    const timer = setInterval(() => setIdx(i => (i + 1) % steps.length), 4000);
    return () => clearInterval(timer);
  }, [idx, m]);
  return /*#__PURE__*/React.createElement("section", {
    id: "story",
    "data-screen-label": "How it's made",
    style: {
      position: 'relative',
      background: P(c.bg, 'var(--cravy-yellow)'),
      padding: 'clamp(70px,10vh,130px) clamp(16px,2.5vw,44px) clamp(60px,9vh,110px)',
      boxSizing: 'border-box',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-body)',
      fontWeight: 700,
      fontSize: 'clamp(13px,1vw,18px)',
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      color: '#000',
      marginBottom: 52
    },
    dangerouslySetInnerHTML: H(P(c.eyebrow, '02 How we fry'))
  }), /*#__PURE__*/React.createElement("h2", {
    style: {
      color: '#000'
    },
    dangerouslySetInnerHTML: H(P(c.heading, 'The open secret'))
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: m ? 'column' : 'row',
      gap: 'clamp(10px,1.2vw,22px)',
      marginTop: 'clamp(34px,6vh,72px)',
      height: m ? 'auto' : 'clamp(340px,46vh,460px)'
    }
  }, steps.map((s, i) => {
    const on = m || i === idx; // mobile: every step expanded
    return /*#__PURE__*/React.createElement("div", {
      key: s.n,
      onClick: () => setIdx(i),
      style: m ? {
        maxHeight: on ? 900 : 64,
        background: on ? '#fff' : s.c,
        borderRadius: 26,
        cursor: 'pointer',
        overflow: 'hidden',
        display: 'flex',
        transition: 'max-height .9s cubic-bezier(.33,0,.12,1), background .6s ease',
        position: 'relative'
      } : {
        flex: on ? '1 1 auto' : '0 0 clamp(70px,7vw,120px)',
        background: on ? '#fff' : s.c,
        borderRadius: 37.235,
        cursor: 'pointer',
        overflow: 'hidden',
        display: 'flex',
        transition: 'flex .9s cubic-bezier(.33,0,.12,1), background .6s ease',
        position: 'relative'
      }
    }, on ? /*#__PURE__*/React.createElement("div", {
      key: 'c' + s.n,
      style: {
        display: 'flex',
        flexDirection: m ? 'column' : 'row',
        gap: 'clamp(16px,2vw,34px)',
        padding: 'clamp(16px,2vw,34px)',
        alignItems: 'stretch',
        width: '100%',
        color: '#000',
        animation: 'fadein .7s cubic-bezier(.22,.9,.3,1) .25s both'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: m ? '0 0 auto' : '0 0 44%',
        aspectRatio: m ? '16/10' : 'auto',
        borderRadius: 24,
        overflow: 'hidden',
        position: 'relative',
        background: s.c
      }
    }, /*#__PURE__*/React.createElement("image-slot", {
      id: 'story-' + s.n,
      src: s.img,
      fit: "cover",
      shape: "rounded",
      radius: "24",
      placeholder: 'Drop a "' + s.h + '" photo'
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 12,
        fontFamily: 'var(--font-body)',
        minWidth: 0
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontWeight: 700,
        fontSize: 'clamp(13px,1vw,17px)',
        letterSpacing: '0.1em',
        color: s.c
      }
    }, "STEP ", s.n), /*#__PURE__*/React.createElement("div", {
      style: {
        fontFamily: 'var(--font-statement)',
        fontWeight: 400,
        textTransform: 'uppercase',
        letterSpacing: '-0.03em',
        fontSize: 'clamp(30px,3vw,56px)',
        lineHeight: 1
      },
      dangerouslySetInnerHTML: H(s.h)
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        fontWeight: 400,
        fontSize: 'clamp(14px,1.2vw,20px)',
        lineHeight: 1.3,
        maxWidth: 520
      },
      dangerouslySetInnerHTML: H(s.b)
    }), /*#__PURE__*/React.createElement("a", {
      href: "#story",
      className: "addbtn",
      style: {
        alignSelf: 'flex-start',
        fontWeight: 700,
        fontSize: 13,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        padding: '12px 22px',
        background: '#000',
        color: '#fff',
        borderRadius: 999,
        marginTop: 6,
        textDecoration: 'none'
      }
    }, "Read more"))) : m ? /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        height: 64,
        padding: '0 22px',
        boxSizing: 'border-box',
        fontFamily: 'var(--font-body)',
        fontWeight: 700,
        fontSize: 16,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: '#fff'
      }
    }, /*#__PURE__*/React.createElement("span", null, s.n, " — ", s.label), /*#__PURE__*/React.createElement("svg", {
      width: "18",
      height: "18",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "#fff",
      strokeWidth: "3",
      strokeLinecap: "round"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M6 9l6 6 6-6"
    }))) : /*#__PURE__*/React.createElement("div", {
      style: {
        margin: 'auto',
        fontFamily: 'var(--font-body)',
        fontWeight: 700,
        fontSize: 'clamp(16px,1.3vw,24px)',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: '#fff',
        writingMode: 'vertical-rl',
        transform: 'rotate(180deg)',
        whiteSpace: 'nowrap'
      }
    }, s.n, " — ", s.label));
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: m ? 'none' : 'flex',
      gap: 12,
      justifyContent: 'center',
      marginTop: 'clamp(30px,5vh,56px)'
    }
  }, steps.map((s, i) => /*#__PURE__*/React.createElement("div", {
    key: s.n,
    onClick: () => setIdx(i),
    style: {
      width: 64,
      height: 7,
      borderRadius: 999,
      background: 'rgba(0,0,0,0.18)',
      overflow: 'hidden',
      cursor: 'pointer'
    }
  }, i === idx && /*#__PURE__*/React.createElement("div", {
    key: idx,
    style: {
      height: '100%',
      background: '#000',
      borderRadius: 999,
      animation: 'load 4s linear forwards'
    }
  })))));
}
window.CravyHome.story = Story;

// ---- REVIEWS ----
function Reviews({
  cfg
}) {
  const c = cfg || {};
  const accent = P(c.bg, 'var(--cravy-green)');
  const quotes = [{
    h: P(c.rev1_h, 'Best fries ever!'),
    q: P(c.rev1_q, 'These are dangerously good. The bag never survives movie night.'),
    a: P(c.rev1_a, 'Maya R.')
  }, {
    h: P(c.rev2_h, 'Crispy every time'),
    q: P(c.rev2_q, 'Crispiest frozen fries I have ever made at home. Period.'),
    a: P(c.rev2_a, 'Devon K.')
  }, {
    h: P(c.rev3_h, 'Kid approved'),
    q: P(c.rev3_q, 'My kids ask for Cravy by name now. Send help.'),
    a: P(c.rev3_a, 'Priya S.')
  }, {
    h: P(c.rev4_h, 'Food-truck level'),
    q: P(c.rev4_q, 'Ten minutes in the oven and it tastes like a food truck.'),
    a: P(c.rev4_a, 'Jonas M.')
  }, {
    h: P(c.rev5_h, 'Risk of addiction'),
    q: P(c.rev5_q, 'So golden and crunchy, with a fluffy inside. Truly addictive.'),
    a: P(c.rev5_a, 'Sandra D.')
  }];
  const [off, setOff] = React.useState(0);
  const m = useIsMobile();
  const n = quotes.length;
  const at = i => quotes[(i % n + n) % n];
  const btn = {
    width: 58,
    height: 58,
    borderRadius: '50%',
    background: '#fff',
    color: '#000',
    border: 'none',
    cursor: 'pointer',
    fontSize: 22,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
  const Card = ({
    r,
    center
  }) => /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      minWidth: 0,
      borderRadius: 10,
      padding: 'clamp(24px,2.4vw,40px)',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      background: center ? '#fff' : 'rgba(255,255,255,0.08)',
      border: center ? 'none' : '1px solid rgba(255,255,255,0.55)',
      color: center ? 'var(--cravy-green)' : '#fff',
      backdropFilter: center ? 'none' : 'blur(2px)',
      transition: 'background .4s ease, color .4s ease'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 17,
      letterSpacing: 4,
      color: center ? 'var(--cravy-green)' : 'rgba(255,255,255,0.85)'
    }
  }, "★★★★★"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-body)',
      fontWeight: 700,
      fontSize: 'clamp(24px,2.2vw,36px)',
      lineHeight: 1.05,
      margin: '26px 0 14px'
    },
    dangerouslySetInnerHTML: H(r.h)
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: 'var(--font-body)',
      fontWeight: 500,
      fontSize: 'clamp(15px,1.3vw,21px)',
      lineHeight: 1.3,
      margin: 0
    },
    dangerouslySetInnerHTML: H(r.q)
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: center ? '1px solid rgba(0,0,0,0.15)' : '1px solid rgba(255,255,255,0.4)',
      marginTop: 'auto',
      paddingTop: 18,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontFamily: 'var(--font-body)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 700,
      fontSize: 'clamp(15px,1.2vw,20px)'
    },
    dangerouslySetInnerHTML: H(r.a)
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 7,
      fontWeight: 500,
      fontSize: 14
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "17",
    height: "17",
    viewBox: "0 0 24 24",
    fill: center ? 'var(--cravy-green)' : '#8fbf7f'
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1l2.6 2 3.2-.4 1.2 3 3 1.2-.4 3.2 2 2.6-2 2.6.4 3.2-3 1.2-1.2 3-3.2-.4-2.6 2-2.6-2-3.2.4-1.2-3-3-1.2.4-3.2-2-2.6 2-2.6-.4-3.2 3-1.2 1.2-3 3.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6 15.4l-2.8-2.8 1.2-1.2 1.6 1.6 4.2-4.2 1.2 1.2z",
    fill: center ? '#fff' : accent
  })), "Verified")));
  return /*#__PURE__*/React.createElement("section", {
    id: "reviews",
    "data-screen-label": "Reviews",
    style: {
      position: 'relative',
      background: accent,
      minHeight: '100vh',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      padding: 'clamp(60px,9vh,120px) clamp(16px,2.5vw,44px) clamp(24px,3.5vh,48px)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      zIndex: 0
    }
  }, /*#__PURE__*/React.createElement("image-slot", {
    id: "reviews-bg",
    shape: "rect",
    fit: "cover",
    src: P(c.bgimg, ''),
    placeholder: "Drop full-bleed background photo (fries hero shot)",
    style: {
      width: '100%',
      height: '100%'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      background: 'rgba(0,0,0,0.18)'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      zIndex: 1,
      textAlign: 'center',
      marginTop: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Reveal, {
    as: "h2",
    kind: "up",
    style: {
      color: '#fff'
    },
    dangerouslySetInnerHTML: H(P(c.heading, 'Don’t take our word for it'))
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 14,
      justifyContent: 'center',
      marginTop: 30
    }
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "Previous review",
    onClick: () => setOff(o => o - 1),
    style: btn
  }, "←"), /*#__PURE__*/React.createElement("button", {
    "aria-label": "Next review",
    onClick: () => setOff(o => o + 1),
    style: btn
  }, "→"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      zIndex: 1,
      marginTop: 'clamp(30px,5vh,60px)',
      height: m ? 'clamp(360px,52vh,480px)' : 'clamp(300px,38vh,420px)',
      overflow: 'hidden'
    }
  }, [-2, -1, 0, 1, 2, 3, 4].map(d => {
    const i2 = off + d;
    return /*#__PURE__*/React.createElement("div", {
      key: i2,
      style: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: m ? '4%' : 0,
        width: m ? '92%' : 'calc(100%/3)',
        transform: `translateX(${(i2 - off) * 100}%)`,
        transition: 'transform .65s cubic-bezier(.22,.9,.3,1)',
        padding: '0 clamp(7px,.9vw,15px)',
        boxSizing: 'border-box'
      }
    }, /*#__PURE__*/React.createElement(Card, {
      r: at(i2),
      center: i2 - off === (m ? 0 : 1)
    }));
  })));
}
window.CravyHome.reviews = Reviews;

// ---- SOCIALS (Instagram grid) ----
function Socials({
  cfg
}) {
  const c = cfg || {};
  const m = useIsMobile();
  const nets = [{
    n: 'Instagram',
    href: P(c.instagram, '')
  }, {
    n: 'Facebook',
    href: P(c.facebook, '')
  }, {
    n: 'TikTok',
    href: P(c.tiktok, '')
  }];
  const cards = [{
    id: 'social-1',
    h: 380,
    img: P(c.img1, '')
  }, {
    id: 'social-2',
    h: 440,
    img: P(c.img2, '')
  }, {
    id: 'social-3',
    h: 320,
    img: P(c.img3, '')
  }, {
    id: 'social-4',
    h: 420,
    img: P(c.img4, '')
  }, {
    id: 'social-5',
    h: 360,
    img: P(c.img5, '')
  }];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Socials",
    style: {
      background: P(c.bg, 'var(--cravy-orange)'),
      padding: 'clamp(70px,10vh,130px) 0 clamp(60px,8vh,100px)',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      padding: '0 clamp(20px,5vw,80px)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-body)',
      fontWeight: 700,
      fontSize: 'clamp(13px,1vw,18px)',
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      color: '#fff',
      marginBottom: 52
    },
    dangerouslySetInnerHTML: H(P(c.eyebrow, 'Join the craving'))
  }), /*#__PURE__*/React.createElement("h2", {
    style: {
      color: '#fff'
    },
    dangerouslySetInnerHTML: H(P(c.heading, 'Follow @cravyfries for more'))
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 16,
      justifyContent: 'center',
      flexWrap: 'wrap',
      marginTop: 'clamp(30px,5vh,54px)',
      padding: '0 20px'
    }
  }, nets.map(net => /*#__PURE__*/React.createElement("a", {
    key: net.n,
    href: net.href || '#',
    target: "_blank",
    rel: "noopener",
    className: "socialbtn",
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 40,
      minWidth: 250,
      textDecoration: 'none',
      background: 'var(--cravy-maroon)',
      color: '#fff',
      borderRadius: 14,
      padding: '16px 16px 16px 24px',
      fontFamily: 'var(--font-body)',
      fontWeight: 700,
      fontSize: 16
    }
  }, net.n, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 34,
      height: 34,
      borderRadius: 999,
      background: '#fff',
      color: 'var(--cravy-maroon)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 18
    }
  }, "→")))), /*#__PURE__*/React.createElement("div", {
    id: "cravy-instafeed",
    style: {
      overflow: 'hidden',
      marginTop: 'clamp(46px,7vh,90px)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: m ? 16 : 'clamp(14px,1.6vw,26px)',
      alignItems: 'center',
      justifyContent: m ? 'flex-start' : 'center',
      width: m ? 'max-content' : 'auto',
      padding: '0 10px',
      animation: m ? 'marq 28s linear infinite' : 'none'
    }
  }, (m ? cards.concat(cards) : cards).map((cd, i) => /*#__PURE__*/React.createElement("div", {
    key: cd.id + '-' + i,
    className: "socard",
    style: {
      position: 'relative',
      flex: m ? '0 0 74vw' : '0 0 clamp(200px,18vw,300px)',
      height: m ? Math.round(cd.h * 1.15) : cd.h,
      borderRadius: 16,
      overflow: 'hidden',
      transform: `rotate(calc(${i % 2 ? 1 : -1}deg*var(--k,1)))`
    }
  }, /*#__PURE__*/React.createElement("image-slot", {
    id: cd.id,
    shape: "rounded",
    radius: "16",
    fit: "cover",
    src: cd.img,
    placeholder: "Drop a social post image"
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      top: 14,
      left: 14,
      background: '#000',
      color: '#fff',
      fontFamily: 'var(--font-body)',
      fontWeight: 600,
      fontSize: 12.5,
      padding: '8px 14px',
      borderRadius: 999,
      pointerEvents: 'none'
    }
  }, "Instagram"))))));
}
window.CravyHome.socials = Socials;

// ---- INQUIRY (wholesale CTA) ----
function Inquiry({
  cfg
}) {
  const c = cfg || {};
  return /*#__PURE__*/React.createElement("section", {
    id: "inquiry",
    "data-screen-label": "Inquiry",
    style: {
      background: P(c.bg, 'var(--cravy-red)'),
      padding: 'clamp(90px,13vh,170px) clamp(16px,4vw,70px) clamp(70px,10vh,120px)',
      position: 'relative',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      maxWidth: 1240,
      margin: '0 auto'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: P(c.card_bg, 'var(--cravy-yellow)'),
      borderRadius: 37.235,
      padding: 'clamp(50px,7vw,100px) clamp(24px,5vw,90px) clamp(44px,5vw,80px)',
      textAlign: 'center',
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      color: '#000'
    },
    dangerouslySetInnerHTML: H(P(c.heading, 'Fries for your business.'))
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '22px auto 0',
      maxWidth: 560,
      fontFamily: 'var(--font-body)',
      fontWeight: 400,
      fontSize: 'clamp(16px,1.3vw,21px)',
      lineHeight: 1.3,
      color: '#000'
    },
    dangerouslySetInnerHTML: H(P(c.body, 'From cafés to restaurants, Cravy supplies premium frozen fries that are easy to prepare and loved by customers.'))
  }), /*#__PURE__*/React.createElement("a", {
    className: "herobtn herobtn-dark",
    href: P(c.btn_link, '/pages/about#inquiry'),
    style: {
      display: 'inline-block',
      marginTop: 'clamp(28px,4vh,44px)',
      fontFamily: 'var(--font-body)',
      fontWeight: 700,
      fontSize: 15,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      padding: '18px 34px',
      background: '#000',
      color: '#fff',
      borderRadius: 12,
      textDecoration: 'none'
    }
  }, P(c.btn_text, 'Become a partner')))));
}
window.CravyHome.inquiry = Inquiry;
Object.assign(window, {
  CurvedMarquee,
  HomeCurve,
  WhyPeople,
  Statement,
  Story,
  Reviews,
  Socials,
  Inquiry
});

